import { useMutation } from '@apollo/client';
import { DELETE_CURRICULUM_MUTATION } from '../../mutations';

export function useDeleteCurriculumMutation() {
    return useMutation( DELETE_CURRICULUM_MUTATION );
}
